// extracted by mini-css-extract-plugin
module.exports = {"spp0m5g":"spp0m5g","disabled":"disabled","selected":"selected","checkbox-button":"checkbox-button","loading":"loading","icon":"icon"};